module.exports = __webpack_public_path__ + "img/btn_shitu.7859a6a1.png";